export default __webpack_public_path__ + "static/media/bg-change-device-stub.7f440666.png";